/** customscrollbar vscroll */
!(function (factory) {
  "function" == typeof define && define.amd
    ? define(["jquery"], factory)
    : "undefined" != typeof module && module.exports
    ? (module.exports = factory)
    : factory(jQuery, window, document);
})(function ($) {
  var init, _rjs, _njs, _dlp, _url;
  (init = function () {
    var pluginNS = "mCustomScrollbar",
      pluginPfx = "mCS",
      defaultSelector = ".mCustomScrollbar",
      defaults = {
        setTop: 0,
        setLeft: 0,
        axis: "y",
        scrollbarPosition: "inside",
        scrollInertia: 950,
        autoDraggerLength: !0,
        alwaysShowScrollbar: 0,
        snapOffset: 0,
        mouseWheel: {
          enable: !0,
          scrollAmount: "auto",
          axis: "y",
          deltaFactor: "auto",
          disableOver: ["select", "option", "keygen", "datalist", "textarea"],
        },
        scrollButtons: { scrollType: "stepless", scrollAmount: "auto" },
        keyboard: { enable: !0, scrollType: "stepless", scrollAmount: "auto" },
        contentTouchScroll: 25,
        documentTouchScroll: !0,
        advanced: {
          autoScrollOnFocus:
            "input,textarea,select,button,datalist,keygen,a[tabindex],area,object,[contenteditable='true']",
          updateOnContentResize: !0,
          updateOnImageLoad: "auto",
          autoUpdateTimeout: 60,
        },
        theme: "light",
        callbacks: {
          onTotalScrollOffset: 0,
          onTotalScrollBackOffset: 0,
          alwaysTriggerOffsets: !0,
        },
      },
      totalInstances = 0,
      liveTimers = {},
      oldIE = window.attachEvent && !window.addEventListener ? 1 : 0,
      touchActive = !1,
      touchable,
      classes = [
        "mCSB_dragger_onDrag",
        "mCSB_scrollTools_onDrag",
        "mCS_img_loaded",
        "mCS_disabled",
        "mCS_destroyed",
        "mCS_no_scrollbar",
        "mCS-autoHide",
        "mCS-dir-rtl",
        "mCS_no_scrollbar_y",
        "mCS_no_scrollbar_x",
        "mCS_y_hidden",
        "mCS_x_hidden",
        "mCSB_draggerContainer",
        "mCSB_buttonUp",
        "mCSB_buttonDown",
        "mCSB_buttonLeft",
        "mCSB_buttonRight",
      ],
      methods = {
        init: function (options) {
          var options = $.extend(!0, {}, defaults, options),
            selector = _selector.call(this);
          if (options.live) {
            var liveSelector =
                options.liveSelector || this.selector || defaultSelector,
              $liveSelector = $(liveSelector);
            if ("off" === options.live)
              return void removeLiveTimers(liveSelector);
            liveTimers[liveSelector] = setTimeout(function () {
              $liveSelector.mCustomScrollbar(options),
                "once" === options.live &&
                  $liveSelector.length &&
                  removeLiveTimers(liveSelector);
            }, 500);
          } else removeLiveTimers(liveSelector);
          return (
            (options.setWidth = options.set_width
              ? options.set_width
              : options.setWidth),
            (options.setHeight = options.set_height
              ? options.set_height
              : options.setHeight),
            (options.axis = options.horizontalScroll
              ? "x"
              : _findAxis(options.axis)),
            (options.scrollInertia =
              options.scrollInertia > 0 && options.scrollInertia < 17
                ? 17
                : options.scrollInertia),
            "object" != typeof options.mouseWheel &&
              1 == options.mouseWheel &&
              (options.mouseWheel = {
                enable: !0,
                scrollAmount: "auto",
                axis: "y",
                preventDefault: !1,
                deltaFactor: "auto",
                normalizeDelta: !1,
                invert: !1,
              }),
            (options.mouseWheel.scrollAmount = options.mouseWheelPixels
              ? options.mouseWheelPixels
              : options.mouseWheel.scrollAmount),
            (options.mouseWheel.normalizeDelta = options.advanced
              .normalizeMouseWheelDelta
              ? options.advanced.normalizeMouseWheelDelta
              : options.mouseWheel.normalizeDelta),
            (options.scrollButtons.scrollType = _findScrollButtonsType(
              options.scrollButtons.scrollType
            )),
            _theme(options),
            $(selector).each(function () {
              var $this = $(this);
              if (!$this.data("mCS")) {
                $this.data("mCS", {
                  idx: ++totalInstances,
                  opt: options,
                  scrollRatio: { y: null, x: null },
                  overflowed: null,
                  contentReset: { y: null, x: null },
                  bindEvents: !1,
                  tweenRunning: !1,
                  sequential: {},
                  langDir: $this.css("direction"),
                  cbOffsets: null,
                  trigger: null,
                  poll: {
                    size: { o: 0, n: 0 },
                    img: { o: 0, n: 0 },
                    change: { o: 0, n: 0 },
                  },
                });
                var d = $this.data("mCS"),
                  o = d.opt,
                  htmlDataAxis = $this.data("mcs-axis"),
                  htmlDataSbPos = $this.data("mcs-scrollbar-position"),
                  htmlDataTheme = $this.data("mcs-theme");
                htmlDataAxis && (o.axis = htmlDataAxis),
                  htmlDataSbPos && (o.scrollbarPosition = htmlDataSbPos),
                  htmlDataTheme && ((o.theme = htmlDataTheme), _theme(o)),
                  _pluginMarkup.call(this),
                  d &&
                    o.callbacks.onCreate &&
                    "function" == typeof o.callbacks.onCreate &&
                    o.callbacks.onCreate.call(this),
                  $(
                    "#mCSB_" + d.idx + "_container img:not(." + classes[2] + ")"
                  ).addClass(classes[2]),
                  methods.update.call(null, $this);
              }
            })
          );
        },
        update: function (el, cb) {
          var selector = el || _selector.call(this);
          return $(selector).each(function () {
            var $this = $(this);
            if ($this.data("mCS")) {
              var d = $this.data("mCS"),
                o = d.opt,
                mCSB_container = $("#mCSB_" + d.idx + "_container"),
                mCustomScrollBox = $("#mCSB_" + d.idx),
                mCSB_dragger = [
                  $("#mCSB_" + d.idx + "_dragger_vertical"),
                  $("#mCSB_" + d.idx + "_dragger_horizontal"),
                ];
              if (!mCSB_container.length) return;
              d.tweenRunning && _stop($this),
                cb &&
                  d &&
                  o.callbacks.onBeforeUpdate &&
                  "function" == typeof o.callbacks.onBeforeUpdate &&
                  o.callbacks.onBeforeUpdate.call(this),
                $this.hasClass(classes[3]) && $this.removeClass(classes[3]),
                $this.hasClass(classes[4]) && $this.removeClass(classes[4]),
                mCustomScrollBox.css("max-height", "none"),
                mCustomScrollBox.height() !== $this.height() &&
                  mCustomScrollBox.css("max-height", $this.height()),
                _expandContentHorizontally.call(this),
                "y" === o.axis ||
                  o.advanced.autoExpandHorizontalScroll ||
                  mCSB_container.css("width", _contentWidth(mCSB_container)),
                (d.overflowed = _overflowed.call(this)),
                _scrollbarVisibility.call(this),
                o.autoDraggerLength && _setDraggerLength.call(this),
                _scrollRatio.call(this),
                _bindEvents.call(this);
              var to = [
                Math.abs(mCSB_container[0].offsetTop),
                Math.abs(mCSB_container[0].offsetLeft),
              ];
              "x" !== o.axis &&
                (d.overflowed[0]
                  ? mCSB_dragger[0].height() > mCSB_dragger[0].parent().height()
                    ? _resetContentPosition.call(this)
                    : (_scrollTo($this, to[0].toString(), {
                        dir: "y",
                        dur: 0,
                        overwrite: "none",
                      }),
                      (d.contentReset.y = null))
                  : (_resetContentPosition.call(this),
                    "y" === o.axis
                      ? _unbindEvents.call(this)
                      : "yx" === o.axis &&
                        d.overflowed[1] &&
                        _scrollTo($this, to[1].toString(), {
                          dir: "x",
                          dur: 0,
                          overwrite: "none",
                        }))),
                "y" !== o.axis &&
                  (d.overflowed[1]
                    ? mCSB_dragger[1].width() > mCSB_dragger[1].parent().width()
                      ? _resetContentPosition.call(this)
                      : (_scrollTo($this, to[1].toString(), {
                          dir: "x",
                          dur: 0,
                          overwrite: "none",
                        }),
                        (d.contentReset.x = null))
                    : (_resetContentPosition.call(this),
                      "x" === o.axis
                        ? _unbindEvents.call(this)
                        : "yx" === o.axis &&
                          d.overflowed[0] &&
                          _scrollTo($this, to[0].toString(), {
                            dir: "y",
                            dur: 0,
                            overwrite: "none",
                          }))),
                cb &&
                  d &&
                  (2 === cb &&
                  o.callbacks.onImageLoad &&
                  "function" == typeof o.callbacks.onImageLoad
                    ? o.callbacks.onImageLoad.call(this)
                    : 3 === cb &&
                      o.callbacks.onSelectorChange &&
                      "function" == typeof o.callbacks.onSelectorChange
                    ? o.callbacks.onSelectorChange.call(this)
                    : o.callbacks.onUpdate &&
                      "function" == typeof o.callbacks.onUpdate &&
                      o.callbacks.onUpdate.call(this)),
                _autoUpdate.call(this);
            }
          });
        },
        scrollTo: function (val, options) {
          if (void 0 !== val && null != val) {
            var selector = _selector.call(this);
            return $(selector).each(function () {
              var $this = $(this);
              if ($this.data("mCS")) {
                var d = $this.data("mCS"),
                  o = d.opt,
                  methodDefaults = {
                    trigger: "external",
                    scrollInertia: o.scrollInertia,
                    scrollEasing: "mcsEaseInOut",
                    moveDragger: !1,
                    timeout: 60,
                    callbacks: !0,
                    onStart: !0,
                    onUpdate: !0,
                    onComplete: !0,
                  },
                  methodOptions = $.extend(!0, {}, methodDefaults, options),
                  to = _arr.call(this, val),
                  dur =
                    methodOptions.scrollInertia > 0 &&
                    methodOptions.scrollInertia < 17
                      ? 17
                      : methodOptions.scrollInertia;
                (to[0] = _to.call(this, to[0], "y")),
                  (to[1] = _to.call(this, to[1], "x")),
                  methodOptions.moveDragger &&
                    ((to[0] *= d.scrollRatio.y), (to[1] *= d.scrollRatio.x)),
                  (methodOptions.dur = _isTabHidden() ? 0 : dur),
                  setTimeout(function () {
                    null !== to[0] &&
                      void 0 !== to[0] &&
                      "x" !== o.axis &&
                      d.overflowed[0] &&
                      ((methodOptions.dir = "y"),
                      (methodOptions.overwrite = "all"),
                      _scrollTo($this, to[0].toString(), methodOptions)),
                      null !== to[1] &&
                        void 0 !== to[1] &&
                        "y" !== o.axis &&
                        d.overflowed[1] &&
                        ((methodOptions.dir = "x"),
                        (methodOptions.overwrite = "none"),
                        _scrollTo($this, to[1].toString(), methodOptions));
                  }, methodOptions.timeout);
              }
            });
          }
        },
        stop: function () {
          var selector = _selector.call(this);
          return $(selector).each(function () {
            var $this = $(this);
            $this.data("mCS") && _stop($this);
          });
        },
        disable: function (r) {
          var selector = _selector.call(this);
          return $(selector).each(function () {
            var $this = $(this);
            if ($this.data("mCS")) {
              var d = $this.data("mCS");
              _autoUpdate.call(this, "remove"),
                _unbindEvents.call(this),
                r && _resetContentPosition.call(this),
                _scrollbarVisibility.call(this, !0),
                $this.addClass(classes[3]);
            }
          });
        },
        destroy: function () {
          var selector = _selector.call(this);
          return $(selector).each(function () {
            var $this = $(this);
            if ($this.data("mCS")) {
              var d = $this.data("mCS"),
                o = d.opt,
                mCustomScrollBox = $("#mCSB_" + d.idx),
                mCSB_container = $("#mCSB_" + d.idx + "_container"),
                scrollbar = $(".mCSB_" + d.idx + "_scrollbar");
              o.live &&
                removeLiveTimers(o.liveSelector || $(selector).selector),
                _autoUpdate.call(this, "remove"),
                _unbindEvents.call(this),
                _resetContentPosition.call(this),
                $this.removeData("mCS"),
                _delete(this, "mcs"),
                scrollbar.remove(),
                mCSB_container
                  .find("img." + classes[2])
                  .removeClass(classes[2]),
                mCustomScrollBox.replaceWith(mCSB_container.contents()),
                $this
                  .removeClass(
                    pluginNS +
                      " _mCS_" +
                      d.idx +
                      " " +
                      classes[6] +
                      " " +
                      classes[7] +
                      " " +
                      classes[5] +
                      " " +
                      classes[3]
                  )
                  .addClass(classes[4]);
            }
          });
        },
      },
      _selector = function () {
        return "object" != typeof $(this) || $(this).length < 1
          ? defaultSelector
          : this;
      },
      _theme = function (obj) {
        var fixedSizeScrollbarThemes = [
            "rounded",
            "rounded-dark",
            "rounded-dots",
            "rounded-dots-dark",
          ],
          nonExpandedScrollbarThemes = [
            "rounded-dots",
            "rounded-dots-dark",
            "3d",
            "3d-dark",
            "3d-thick",
            "3d-thick-dark",
            "inset",
            "inset-dark",
            "inset-2",
            "inset-2-dark",
            "inset-3",
            "inset-3-dark",
          ],
          disabledScrollButtonsThemes = ["minimal", "minimal-dark"],
          enabledAutoHideScrollbarThemes = ["minimal", "minimal-dark"],
          scrollbarPositionOutsideThemes = ["minimal", "minimal-dark"];
        (obj.autoDraggerLength =
          !($.inArray(obj.theme, fixedSizeScrollbarThemes) > -1) &&
          obj.autoDraggerLength),
          (obj.autoExpandScrollbar =
            !($.inArray(obj.theme, nonExpandedScrollbarThemes) > -1) &&
            obj.autoExpandScrollbar),
          (obj.scrollButtons.enable =
            !($.inArray(obj.theme, disabledScrollButtonsThemes) > -1) &&
            obj.scrollButtons.enable),
          (obj.autoHideScrollbar =
            $.inArray(obj.theme, enabledAutoHideScrollbarThemes) > -1 ||
            obj.autoHideScrollbar),
          (obj.scrollbarPosition =
            $.inArray(obj.theme, scrollbarPositionOutsideThemes) > -1
              ? "outside"
              : obj.scrollbarPosition);
      },
      removeLiveTimers = function (selector) {
        liveTimers[selector] &&
          (clearTimeout(liveTimers[selector]), _delete(liveTimers, selector));
      },
      _findAxis = function (val) {
        return "yx" === val || "xy" === val || "auto" === val
          ? "yx"
          : "x" === val || "horizontal" === val
          ? "x"
          : "y";
      },
      _findScrollButtonsType = function (val) {
        return "stepped" === val ||
          "pixels" === val ||
          "step" === val ||
          "click" === val
          ? "stepped"
          : "stepless";
      },
      _pluginMarkup = function () {
        var $this = $(this),
          d = $this.data("mCS"),
          o = d.opt,
          expandClass = o.autoExpandScrollbar
            ? " " + classes[1] + "_expand"
            : "",
          scrollbar = [
            "<div id='mCSB_" +
              d.idx +
              "_scrollbar_vertical' class='mCSB_scrollTools mCSB_" +
              d.idx +
              "_scrollbar mCS-" +
              o.theme +
              " mCSB_scrollTools_vertical" +
              expandClass +
              "'><div class='" +
              classes[12] +
              "'><div id='mCSB_" +
              d.idx +
              "_dragger_vertical' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>",
            "<div id='mCSB_" +
              d.idx +
              "_scrollbar_horizontal' class='mCSB_scrollTools mCSB_" +
              d.idx +
              "_scrollbar mCS-" +
              o.theme +
              " mCSB_scrollTools_horizontal" +
              expandClass +
              "'><div class='" +
              classes[12] +
              "'><div id='mCSB_" +
              d.idx +
              "_dragger_horizontal' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>",
          ],
          wrapperClass =
            "yx" === o.axis
              ? "mCSB_vertical_horizontal"
              : "x" === o.axis
              ? "mCSB_horizontal"
              : "mCSB_vertical",
          scrollbars =
            "yx" === o.axis
              ? scrollbar[0] + scrollbar[1]
              : "x" === o.axis
              ? scrollbar[1]
              : scrollbar[0],
          contentWrapper =
            "yx" === o.axis
              ? "<div id='mCSB_" +
                d.idx +
                "_container_wrapper' class='mCSB_container_wrapper' />"
              : "",
          autoHideClass = o.autoHideScrollbar ? " " + classes[6] : "",
          scrollbarDirClass =
            "x" !== o.axis && "rtl" === d.langDir ? " " + classes[7] : "";
        o.setWidth && $this.css("width", o.setWidth),
          o.setHeight && $this.css("height", o.setHeight),
          (o.setLeft =
            "y" !== o.axis && "rtl" === d.langDir ? "989999px" : o.setLeft),
          $this
            .addClass(
              pluginNS + " _mCS_" + d.idx + autoHideClass + scrollbarDirClass
            )
            .wrapInner(
              "<div id='mCSB_" +
                d.idx +
                "' class='mCustomScrollBox mCS-" +
                o.theme +
                " " +
                wrapperClass +
                "'><div id='mCSB_" +
                d.idx +
                "_container' class='mCSB_container' style='position:relative; top:" +
                o.setTop +
                "; left:" +
                o.setLeft +
                ";' dir='" +
                d.langDir +
                "' /></div>"
            );
        var mCustomScrollBox = $("#mCSB_" + d.idx),
          mCSB_container = $("#mCSB_" + d.idx + "_container");
        "y" === o.axis ||
          o.advanced.autoExpandHorizontalScroll ||
          mCSB_container.css("width", _contentWidth(mCSB_container)),
          "outside" === o.scrollbarPosition
            ? ("static" === $this.css("position") &&
                $this.css("position", "relative"),
              $this.css("overflow", "visible"),
              mCustomScrollBox.addClass("mCSB_outside").after(scrollbars))
            : (mCustomScrollBox.addClass("mCSB_inside").append(scrollbars),
              mCSB_container.wrap(contentWrapper)),
          _scrollButtons.call(this);
        var mCSB_dragger = [
          $("#mCSB_" + d.idx + "_dragger_vertical"),
          $("#mCSB_" + d.idx + "_dragger_horizontal"),
        ];
        mCSB_dragger[0].css("min-height", mCSB_dragger[0].height()),
          mCSB_dragger[1].css("min-width", mCSB_dragger[1].width());
      },
      _contentWidth = function (el) {
        var val = [
            el[0].scrollWidth,
            Math.max.apply(
              Math,
              el
                .children()
                .map(function () {
                  return $(this).outerWidth(!0);
                })
                .get()
            ),
          ],
          w = el.parent().width();
        return val[0] > w ? val[0] : val[1] > w ? val[1] : "100%";
      },
      _expandContentHorizontally = function () {
        var $this,
          d = $(this).data("mCS"),
          o = d.opt,
          mCSB_container = $("#mCSB_" + d.idx + "_container");
        if (o.advanced.autoExpandHorizontalScroll && "y" !== o.axis) {
          mCSB_container.css({
            width: "auto",
            "min-width": 0,
            "overflow-x": "scroll",
          });
          var w = Math.ceil(mCSB_container[0].scrollWidth);
          3 === o.advanced.autoExpandHorizontalScroll ||
          (2 !== o.advanced.autoExpandHorizontalScroll &&
            w > mCSB_container.parent().width())
            ? mCSB_container.css({
                width: w,
                "min-width": "100%",
                "overflow-x": "inherit",
              })
            : mCSB_container
                .css({ "overflow-x": "inherit", position: "absolute" })
                .wrap(
                  "<div class='mCSB_h_wrapper' style='position:relative; left:0; width:999999px;' />"
                )
                .css({
                  width:
                    Math.ceil(
                      mCSB_container[0].getBoundingClientRect().right + 0.4
                    ) -
                    Math.floor(mCSB_container[0].getBoundingClientRect().left),
                  "min-width": "100%",
                  position: "relative",
                })
                .unwrap();
        }
      },
      _scrollButtons = function () {
        var $this,
          d = $(this).data("mCS"),
          o = d.opt,
          mCSB_scrollTools = $(".mCSB_" + d.idx + "_scrollbar:first"),
          tabindex = _isNumeric(o.scrollButtons.tabindex)
            ? "tabindex='" + o.scrollButtons.tabindex + "'"
            : "",
          btnHTML = [
            "<a href='#' class='" + classes[13] + "' " + tabindex + " />",
            "<a href='#' class='" + classes[14] + "' " + tabindex + " />",
            "<a href='#' class='" + classes[15] + "' " + tabindex + " />",
            "<a href='#' class='" + classes[16] + "' " + tabindex + " />",
          ],
          btn = [
            "x" === o.axis ? btnHTML[2] : btnHTML[0],
            "x" === o.axis ? btnHTML[3] : btnHTML[1],
            btnHTML[2],
            btnHTML[3],
          ];
        o.scrollButtons.enable &&
          mCSB_scrollTools
            .prepend(btn[0])
            .append(btn[1])
            .next(".mCSB_scrollTools")
            .prepend(btn[2])
            .append(btn[3]);
      },
      _setDraggerLength = function () {
        var $this,
          d = $(this).data("mCS"),
          mCustomScrollBox = $("#mCSB_" + d.idx),
          mCSB_container = $("#mCSB_" + d.idx + "_container"),
          mCSB_dragger = [
            $("#mCSB_" + d.idx + "_dragger_vertical"),
            $("#mCSB_" + d.idx + "_dragger_horizontal"),
          ],
          ratio = [
            mCustomScrollBox.height() / mCSB_container.outerHeight(!1),
            mCustomScrollBox.width() / mCSB_container.outerWidth(!1),
          ],
          l = [
            parseInt(mCSB_dragger[0].css("min-height")),
            Math.round(ratio[0] * mCSB_dragger[0].parent().height()),
            parseInt(mCSB_dragger[1].css("min-width")),
            Math.round(ratio[1] * mCSB_dragger[1].parent().width()),
          ],
          h = oldIE && l[1] < l[0] ? l[0] : l[1],
          w = oldIE && l[3] < l[2] ? l[2] : l[3];
        mCSB_dragger[0]
          .css({
            height: h,
            "max-height": mCSB_dragger[0].parent().height() - 10,
          })
          .find(".mCSB_dragger_bar")
          .css({ "line-height": l[0] + "px" }),
          mCSB_dragger[1].css({
            width: w,
            "max-width": mCSB_dragger[1].parent().width() - 10,
          });
      },
      _scrollRatio = function () {
        var $this,
          d = $(this).data("mCS"),
          mCustomScrollBox = $("#mCSB_" + d.idx),
          mCSB_container = $("#mCSB_" + d.idx + "_container"),
          mCSB_dragger = [
            $("#mCSB_" + d.idx + "_dragger_vertical"),
            $("#mCSB_" + d.idx + "_dragger_horizontal"),
          ],
          scrollAmount = [
            mCSB_container.outerHeight(!1) - mCustomScrollBox.height(),
            mCSB_container.outerWidth(!1) - mCustomScrollBox.width(),
          ],
          ratio = [
            scrollAmount[0] /
              (mCSB_dragger[0].parent().height() - mCSB_dragger[0].height()),
            scrollAmount[1] /
              (mCSB_dragger[1].parent().width() - mCSB_dragger[1].width()),
          ];
        d.scrollRatio = { y: ratio[0], x: ratio[1] };
      },
      _onDragClasses = function (el, action, xpnd) {
        var expandClass = xpnd ? classes[0] + "_expanded" : "",
          scrollbar = el.closest(".mCSB_scrollTools");
        "active" === action
          ? (el.toggleClass(classes[0] + " " + expandClass),
            scrollbar.toggleClass(classes[1]),
            (el[0]._draggable = el[0]._draggable ? 0 : 1))
          : el[0]._draggable ||
            ("hide" === action
              ? (el.removeClass(classes[0]), scrollbar.removeClass(classes[1]))
              : (el.addClass(classes[0]), scrollbar.addClass(classes[1])));
      },
      _overflowed = function () {
        var $this,
          d = $(this).data("mCS"),
          mCustomScrollBox = $("#mCSB_" + d.idx),
          mCSB_container = $("#mCSB_" + d.idx + "_container"),
          contentHeight =
            null == d.overflowed
              ? mCSB_container.height()
              : mCSB_container.outerHeight(!1),
          contentWidth =
            null == d.overflowed
              ? mCSB_container.width()
              : mCSB_container.outerWidth(!1),
          h = mCSB_container[0].scrollHeight,
          w = mCSB_container[0].scrollWidth;
        return (
          h > contentHeight && (contentHeight = h),
          w > contentWidth && (contentWidth = w),
          [
            contentHeight > mCustomScrollBox.height(),
            contentWidth > mCustomScrollBox.width(),
          ]
        );
      },
      _resetContentPosition = function () {
        var $this = $(this),
          d = $this.data("mCS"),
          o = d.opt,
          mCustomScrollBox = $("#mCSB_" + d.idx),
          mCSB_container = $("#mCSB_" + d.idx + "_container"),
          mCSB_dragger = [
            $("#mCSB_" + d.idx + "_dragger_vertical"),
            $("#mCSB_" + d.idx + "_dragger_horizontal"),
          ];
        if (
          (_stop($this),
          (("x" !== o.axis && !d.overflowed[0]) ||
            ("y" === o.axis && d.overflowed[0])) &&
            (mCSB_dragger[0].add(mCSB_container).css("top", 0),
            _scrollTo($this, "_resetY")),
          ("y" !== o.axis && !d.overflowed[1]) ||
            ("x" === o.axis && d.overflowed[1]))
        ) {
          var cx = (dx = 0);
          "rtl" === d.langDir &&
            ((cx = mCustomScrollBox.width() - mCSB_container.outerWidth(!1)),
            (dx = Math.abs(cx / d.scrollRatio.x))),
            mCSB_container.css("left", cx),
            mCSB_dragger[1].css("left", dx),
            _scrollTo($this, "_resetX");
        }
      },
      _bindEvents = function () {
        var $this = $(this),
          d = $this.data("mCS"),
          o = d.opt;
        if (!d.bindEvents) {
          if (
            (_draggable.call(this),
            o.contentTouchScroll && _contentDraggable.call(this),
            _selectable.call(this),
            o.mouseWheel.enable)
          ) {
            function _mwt() {
              mousewheelTimeout = setTimeout(function () {
                $.event.special.mousewheel
                  ? (clearTimeout(mousewheelTimeout),
                    _mousewheel.call($this[0]))
                  : _mwt();
              }, 100);
            }
            var mousewheelTimeout;
            _mwt();
          }
          _draggerRail.call(this),
            _wrapperScroll.call(this),
            o.advanced.autoScrollOnFocus && _focus.call(this),
            o.scrollButtons.enable && _buttons.call(this),
            o.keyboard.enable && _keyboard.call(this),
            (d.bindEvents = !0);
        }
      },
      _unbindEvents = function () {
        var $this = $(this),
          d = $this.data("mCS"),
          o = d.opt,
          namespace = "mCS_" + d.idx,
          sb = ".mCSB_" + d.idx + "_scrollbar",
          sel = $(
            "#mCSB_" +
              d.idx +
              ",#mCSB_" +
              d.idx +
              "_container,#mCSB_" +
              d.idx +
              "_container_wrapper," +
              sb +
              " ." +
              classes[12] +
              ",#mCSB_" +
              d.idx +
              "_dragger_vertical,#mCSB_" +
              d.idx +
              "_dragger_horizontal," +
              sb +
              ">a"
          ),
          mCSB_container = $("#mCSB_" + d.idx + "_container");
        o.advanced.releaseDraggableSelectors &&
          sel.add($(o.advanced.releaseDraggableSelectors)),
          o.advanced.extraDraggableSelectors &&
            sel.add($(o.advanced.extraDraggableSelectors)),
          d.bindEvents &&
            ($(document)
              .add($(!_canAccessIFrame() || top.document))
              .unbind("." + namespace),
            sel.each(function () {
              $(this).unbind("." + namespace);
            }),
            clearTimeout($this[0]._focusTimeout),
            _delete($this[0], "_focusTimeout"),
            clearTimeout(d.sequential.step),
            _delete(d.sequential, "step"),
            clearTimeout(mCSB_container[0].onCompleteTimeout),
            _delete(mCSB_container[0], "onCompleteTimeout"),
            (d.bindEvents = !1));
      },
      _scrollbarVisibility = function (disabled) {
        var $this = $(this),
          d = $this.data("mCS"),
          o = d.opt,
          contentWrapper = $("#mCSB_" + d.idx + "_container_wrapper"),
          content = contentWrapper.length
            ? contentWrapper
            : $("#mCSB_" + d.idx + "_container"),
          scrollbar = [
            $("#mCSB_" + d.idx + "_scrollbar_vertical"),
            $("#mCSB_" + d.idx + "_scrollbar_horizontal"),
          ],
          mCSB_dragger = [
            scrollbar[0].find(".mCSB_dragger"),
            scrollbar[1].find(".mCSB_dragger"),
          ];
        "x" !== o.axis &&
          (d.overflowed[0] && !disabled
            ? (scrollbar[0]
                .add(mCSB_dragger[0])
                .add(scrollbar[0].children("a"))
                .css("display", "block"),
              content.removeClass(classes[8] + " " + classes[10]))
            : (o.alwaysShowScrollbar
                ? (2 !== o.alwaysShowScrollbar &&
                    mCSB_dragger[0].css("display", "none"),
                  content.removeClass(classes[10]))
                : (scrollbar[0].css("display", "none"),
                  content.addClass(classes[10])),
              content.addClass(classes[8]))),
          "y" !== o.axis &&
            (d.overflowed[1] && !disabled
              ? (scrollbar[1]
                  .add(mCSB_dragger[1])
                  .add(scrollbar[1].children("a"))
                  .css("display", "block"),
                content.removeClass(classes[9] + " " + classes[11]))
              : (o.alwaysShowScrollbar
                  ? (2 !== o.alwaysShowScrollbar &&
                      mCSB_dragger[1].css("display", "none"),
                    content.removeClass(classes[11]))
                  : (scrollbar[1].css("display", "none"),
                    content.addClass(classes[11])),
                content.addClass(classes[9]))),
          d.overflowed[0] || d.overflowed[1]
            ? $this.removeClass(classes[5])
            : $this.addClass(classes[5]);
      },
      _coordinates = function (e) {
        var t = e.type,
          o =
            e.target.ownerDocument !== document && null !== frameElement
              ? [$(frameElement).offset().top, $(frameElement).offset().left]
              : null,
          io =
            _canAccessIFrame() &&
            e.target.ownerDocument !== top.document &&
            null !== frameElement
              ? [
                  $(e.view.frameElement).offset().top,
                  $(e.view.frameElement).offset().left,
                ]
              : [0, 0];
        switch (t) {
          case "pointerdown":
          case "MSPointerDown":
          case "pointermove":
          case "MSPointerMove":
          case "pointerup":
          case "MSPointerUp":
            return o
              ? [
                  e.originalEvent.pageY - o[0] + io[0],
                  e.originalEvent.pageX - o[1] + io[1],
                  !1,
                ]
              : [e.originalEvent.pageY, e.originalEvent.pageX, !1];
          case "touchstart":
          case "touchmove":
          case "touchend":
            var touch =
                e.originalEvent.touches[0] || e.originalEvent.changedTouches[0],
              touches =
                e.originalEvent.touches.length ||
                e.originalEvent.changedTouches.length;
            return e.target.ownerDocument !== document
              ? [touch.screenY, touch.screenX, touches > 1]
              : [touch.pageY, touch.pageX, touches > 1];
          default:
            return o
              ? [e.pageY - o[0] + io[0], e.pageX - o[1] + io[1], !1]
              : [e.pageY, e.pageX, !1];
        }
      },
      _draggable = function () {
        var $this = $(this),
          d = $this.data("mCS"),
          o = d.opt,
          namespace = "mCS_" + d.idx,
          draggerId = [
            "mCSB_" + d.idx + "_dragger_vertical",
            "mCSB_" + d.idx + "_dragger_horizontal",
          ],
          mCSB_container = $("#mCSB_" + d.idx + "_container"),
          mCSB_dragger = $("#" + draggerId[0] + ",#" + draggerId[1]),
          draggable,
          dragY,
          dragX,
          rds = o.advanced.releaseDraggableSelectors
            ? mCSB_dragger.add($(o.advanced.releaseDraggableSelectors))
            : mCSB_dragger,
          eds = o.advanced.extraDraggableSelectors
            ? $(!_canAccessIFrame() || top.document).add(
                $(o.advanced.extraDraggableSelectors)
              )
            : $(!_canAccessIFrame() || top.document);
        function _drag(dragY, dragX, y, x) {
          if (
            ((mCSB_container[0].idleTimer = o.scrollInertia < 233 ? 250 : 0),
            draggable.attr("id") === draggerId[1])
          )
            var dir = "x",
              to = (draggable[0].offsetLeft - dragX + x) * d.scrollRatio.x;
          else
            var dir = "y",
              to = (draggable[0].offsetTop - dragY + y) * d.scrollRatio.y;
          _scrollTo($this, to.toString(), { dir: dir, drag: !0 });
        }
        mCSB_dragger
          .bind("contextmenu." + namespace, function (e) {
            e.preventDefault();
          })
          .bind(
            "mousedown." +
              namespace +
              " touchstart." +
              namespace +
              " pointerdown." +
              namespace +
              " MSPointerDown." +
              namespace,
            function (e) {
              if (
                (e.stopImmediatePropagation(),
                e.preventDefault(),
                _mouseBtnLeft(e))
              ) {
                (touchActive = !0),
                  oldIE &&
                    (document.onselectstart = function () {
                      return !1;
                    }),
                  _iframe.call(mCSB_container, !1),
                  _stop($this);
                var offset = (draggable = $(this)).offset(),
                  y = _coordinates(e)[0] - offset.top,
                  x = _coordinates(e)[1] - offset.left,
                  h = draggable.height() + offset.top,
                  w = draggable.width() + offset.left;
                y < h && y > 0 && x < w && x > 0 && ((dragY = y), (dragX = x)),
                  _onDragClasses(draggable, "active", o.autoExpandScrollbar);
              }
            }
          )
          .bind("touchmove." + namespace, function (e) {
            e.stopImmediatePropagation(), e.preventDefault();
            var offset = draggable.offset(),
              y = _coordinates(e)[0] - offset.top,
              x = _coordinates(e)[1] - offset.left;
            _drag(dragY, dragX, y, x);
          }),
          $(document)
            .add(eds)
            .bind(
              "mousemove." +
                namespace +
                " pointermove." +
                namespace +
                " MSPointerMove." +
                namespace,
              function (e) {
                if (draggable) {
                  var offset = draggable.offset(),
                    y = _coordinates(e)[0] - offset.top,
                    x = _coordinates(e)[1] - offset.left;
                  if (dragY === y && dragX === x) return;
                  _drag(dragY, dragX, y, x);
                }
              }
            )
            .add(rds)
            .bind(
              "mouseup." +
                namespace +
                " touchend." +
                namespace +
                " pointerup." +
                namespace +
                " MSPointerUp." +
                namespace,
              function (e) {
                draggable &&
                  (_onDragClasses(draggable, "active", o.autoExpandScrollbar),
                  (draggable = null)),
                  (touchActive = !1),
                  oldIE && (document.onselectstart = null),
                  _iframe.call(mCSB_container, !0);
              }
            );
      },
      _contentDraggable = function () {
        var $this = $(this),
          d = $this.data("mCS"),
          o = d.opt,
          namespace = "mCS_" + d.idx,
          mCustomScrollBox = $("#mCSB_" + d.idx),
          mCSB_container = $("#mCSB_" + d.idx + "_container"),
          mCSB_dragger = [
            $("#mCSB_" + d.idx + "_dragger_vertical"),
            $("#mCSB_" + d.idx + "_dragger_horizontal"),
          ],
          draggable,
          dragY,
          dragX,
          touchStartY,
          touchStartX,
          touchMoveY = [],
          touchMoveX = [],
          startTime,
          runningTime,
          endTime,
          distance,
          speed,
          amount,
          durA = 0,
          durB,
          overwrite = "yx" === o.axis ? "none" : "all",
          touchIntent = [],
          touchDrag,
          docDrag,
          iframe = mCSB_container.find("iframe"),
          events = [
            "touchstart." +
              namespace +
              " pointerdown." +
              namespace +
              " MSPointerDown." +
              namespace,
            "touchmove." +
              namespace +
              " pointermove." +
              namespace +
              " MSPointerMove." +
              namespace,
            "touchend." +
              namespace +
              " pointerup." +
              namespace +
              " MSPointerUp." +
              namespace,
          ],
          touchAction =
            void 0 !== document.body.style.touchAction &&
            "" !== document.body.style.touchAction;
        function _onTouchstart(e) {
          if (!_pointerTouch(e) || touchActive || _coordinates(e)[2])
            touchable = 0;
          else {
            (touchable = 1),
              (touchDrag = 0),
              (docDrag = 0),
              (draggable = 1),
              $this.removeClass("mCS_touch_action");
            var offset = mCSB_container.offset();
            (dragY = _coordinates(e)[0] - offset.top),
              (dragX = _coordinates(e)[1] - offset.left),
              (touchIntent = [_coordinates(e)[0], _coordinates(e)[1]]);
          }
        }
        function _onTouchmove(e) {
          if (
            _pointerTouch(e) &&
            !touchActive &&
            !_coordinates(e)[2] &&
            (o.documentTouchScroll || e.preventDefault(),
            e.stopImmediatePropagation(),
            (!docDrag || touchDrag) && draggable)
          ) {
            runningTime = _getTime();
            var offset = mCustomScrollBox.offset(),
              y = _coordinates(e)[0] - offset.top,
              x = _coordinates(e)[1] - offset.left,
              easing = "mcsLinearOut";
            if (
              (touchMoveY.push(y),
              touchMoveX.push(x),
              (touchIntent[2] = Math.abs(_coordinates(e)[0] - touchIntent[0])),
              (touchIntent[3] = Math.abs(_coordinates(e)[1] - touchIntent[1])),
              d.overflowed[0])
            )
              var limit =
                  mCSB_dragger[0].parent().height() - mCSB_dragger[0].height(),
                prevent =
                  dragY - y > 0 &&
                  y - dragY > -limit * d.scrollRatio.y &&
                  (2 * touchIntent[3] < touchIntent[2] || "yx" === o.axis);
            if (d.overflowed[1])
              var limitX =
                  mCSB_dragger[1].parent().width() - mCSB_dragger[1].width(),
                preventX =
                  dragX - x > 0 &&
                  x - dragX > -limitX * d.scrollRatio.x &&
                  (2 * touchIntent[2] < touchIntent[3] || "yx" === o.axis);
            prevent || preventX
              ? (touchAction || e.preventDefault(), (touchDrag = 1))
              : ((docDrag = 1), $this.addClass("mCS_touch_action")),
              touchAction && e.preventDefault(),
              (amount =
                "yx" === o.axis
                  ? [dragY - y, dragX - x]
                  : "x" === o.axis
                  ? [null, dragX - x]
                  : [dragY - y, null]),
              (mCSB_container[0].idleTimer = 250),
              d.overflowed[0] && _drag(amount[0], 0, easing, "y", "all", !0),
              d.overflowed[1] &&
                _drag(amount[1], 0, easing, "x", overwrite, !0);
          }
        }
        function _onTouchstart2(e) {
          if (!_pointerTouch(e) || touchActive || _coordinates(e)[2])
            touchable = 0;
          else {
            (touchable = 1),
              e.stopImmediatePropagation(),
              _stop($this),
              (startTime = _getTime());
            var offset = mCustomScrollBox.offset();
            (touchStartY = _coordinates(e)[0] - offset.top),
              (touchStartX = _coordinates(e)[1] - offset.left),
              (touchMoveY = []),
              (touchMoveX = []);
          }
        }
        function _onTouchend(e) {
          if (_pointerTouch(e) && !touchActive && !_coordinates(e)[2]) {
            (draggable = 0),
              e.stopImmediatePropagation(),
              (touchDrag = 0),
              (docDrag = 0),
              (endTime = _getTime());
            var offset = mCustomScrollBox.offset(),
              y = _coordinates(e)[0] - offset.top,
              x = _coordinates(e)[1] - offset.left;
            if (!(endTime - runningTime > 30)) {
              var easing = "mcsEaseOut",
                slow = (speed = 1e3 / (endTime - startTime)) < 2.5,
                diff = slow
                  ? [
                      touchMoveY[touchMoveY.length - 2],
                      touchMoveX[touchMoveX.length - 2],
                    ]
                  : [0, 0];
              distance = slow
                ? [y - diff[0], x - diff[1]]
                : [y - touchStartY, x - touchStartX];
              var absDistance = [Math.abs(distance[0]), Math.abs(distance[1])];
              speed = slow
                ? [Math.abs(distance[0] / 4), Math.abs(distance[1] / 4)]
                : [speed, speed];
              var a = [
                Math.abs(mCSB_container[0].offsetTop) -
                  distance[0] * _m(absDistance[0] / speed[0], speed[0]),
                Math.abs(mCSB_container[0].offsetLeft) -
                  distance[1] * _m(absDistance[1] / speed[1], speed[1]),
              ];
              (amount =
                "yx" === o.axis
                  ? [a[0], a[1]]
                  : "x" === o.axis
                  ? [null, a[1]]
                  : [a[0], null]),
                (durB = [
                  4 * absDistance[0] + o.scrollInertia,
                  4 * absDistance[1] + o.scrollInertia,
                ]);
              var md = parseInt(o.contentTouchScroll) || 0;
              (amount[0] = absDistance[0] > md ? amount[0] : 0),
                (amount[1] = absDistance[1] > md ? amount[1] : 0),
                d.overflowed[0] &&
                  _drag(amount[0], durB[0], easing, "y", overwrite, !1),
                d.overflowed[1] &&
                  _drag(amount[1], durB[1], easing, "x", overwrite, !1);
            }
          }
        }
        function _m(ds, s) {
          var r = [1.5 * s, 2 * s, s / 1.5, s / 2];
          return ds > 90
            ? s > 4
              ? r[0]
              : r[3]
            : ds > 60
            ? s > 3
              ? r[3]
              : r[2]
            : ds > 30
            ? s > 8
              ? r[1]
              : s > 6
              ? r[0]
              : s > 4
              ? s
              : r[2]
            : s > 8
            ? s
            : r[3];
        }
        function _drag(amount, dur, easing, dir, overwrite, drag) {
          amount &&
            _scrollTo($this, amount.toString(), {
              dur: dur,
              scrollEasing: easing,
              dir: dir,
              overwrite: overwrite,
              drag: drag,
            });
        }
        mCSB_container
          .bind(events[0], function (e) {
            _onTouchstart(e);
          })
          .bind(events[1], function (e) {
            _onTouchmove(e);
          }),
          mCustomScrollBox
            .bind(events[0], function (e) {
              _onTouchstart2(e);
            })
            .bind(events[2], function (e) {
              _onTouchend(e);
            }),
          iframe.length &&
            iframe.each(function () {
              $(this).bind("load", function () {
                _canAccessIFrame(this) &&
                  $(this.contentDocument || this.contentWindow.document)
                    .bind(events[0], function (e) {
                      _onTouchstart(e), _onTouchstart2(e);
                    })
                    .bind(events[1], function (e) {
                      _onTouchmove(e);
                    })
                    .bind(events[2], function (e) {
                      _onTouchend(e);
                    });
              });
            });
      },
      _selectable = function () {
        var $this = $(this),
          d = $this.data("mCS"),
          o = d.opt,
          seq = d.sequential,
          namespace = "mCS_" + d.idx,
          mCSB_container = $("#mCSB_" + d.idx + "_container"),
          wrapper = mCSB_container.parent(),
          action;
        function _sel() {
          return window.getSelection
            ? window.getSelection().toString()
            : document.selection && "Control" != document.selection.type
            ? document.selection.createRange().text
            : 0;
        }
        function _seq(a, c, s) {
          (seq.type = s && action ? "stepped" : "stepless"),
            (seq.scrollAmount = 10),
            _sequentialScroll($this, a, c, "mcsLinearOut", s ? 60 : null);
        }
        mCSB_container
          .bind("mousedown." + namespace, function (e) {
            touchable || action || ((action = 1), (touchActive = !0));
          })
          .add(document)
          .bind("mousemove." + namespace, function (e) {
            if (!touchable && action && _sel()) {
              var offset = mCSB_container.offset(),
                y =
                  _coordinates(e)[0] - offset.top + mCSB_container[0].offsetTop,
                x =
                  _coordinates(e)[1] -
                  offset.left +
                  mCSB_container[0].offsetLeft;
              y > 0 && y < wrapper.height() && x > 0 && x < wrapper.width()
                ? seq.step && _seq("off", null, "stepped")
                : ("x" !== o.axis &&
                    d.overflowed[0] &&
                    (y < 0
                      ? _seq("on", 38)
                      : y > wrapper.height() && _seq("on", 40)),
                  "y" !== o.axis &&
                    d.overflowed[1] &&
                    (x < 0
                      ? _seq("on", 37)
                      : x > wrapper.width() && _seq("on", 39)));
            }
          })
          .bind("mouseup." + namespace + " dragend." + namespace, function (e) {
            touchable ||
              (action && ((action = 0), _seq("off", null)), (touchActive = !1));
          });
      },
      _mousewheel = function () {
        if ($(this).data("mCS")) {
          var $this = $(this),
            d = $this.data("mCS"),
            o = d.opt,
            namespace = "mCS_" + d.idx,
            mCustomScrollBox = $("#mCSB_" + d.idx),
            mCSB_dragger = [
              $("#mCSB_" + d.idx + "_dragger_vertical"),
              $("#mCSB_" + d.idx + "_dragger_horizontal"),
            ],
            iframe = $("#mCSB_" + d.idx + "_container").find("iframe");
          iframe.length &&
            iframe.each(function () {
              $(this).bind("load", function () {
                _canAccessIFrame(this) &&
                  $(this.contentDocument || this.contentWindow.document).bind(
                    "mousewheel." + namespace,
                    function (e, delta) {
                      _onMousewheel(e, delta);
                    }
                  );
              });
            }),
            mCustomScrollBox.bind(
              "mousewheel." + namespace,
              function (e, delta) {
                _onMousewheel(e, delta);
              }
            );
        }
        function _onMousewheel(e, delta) {
          if ((_stop($this), !_disableMousewheel($this, e.target))) {
            var deltaFactor =
                "auto" !== o.mouseWheel.deltaFactor
                  ? parseInt(o.mouseWheel.deltaFactor)
                  : oldIE && e.deltaFactor < 100
                  ? 100
                  : e.deltaFactor || 100,
              dur = o.scrollInertia;
            if ("x" === o.axis || "x" === o.mouseWheel.axis)
              var dir = "x",
                px = [
                  Math.round(deltaFactor * d.scrollRatio.x),
                  parseInt(o.mouseWheel.scrollAmount),
                ],
                amount =
                  "auto" !== o.mouseWheel.scrollAmount
                    ? px[1]
                    : px[0] >= mCustomScrollBox.width()
                    ? 0.9 * mCustomScrollBox.width()
                    : px[0],
                contentPos = Math.abs(
                  $("#mCSB_" + d.idx + "_container")[0].offsetLeft
                ),
                draggerPos = mCSB_dragger[1][0].offsetLeft,
                limit =
                  mCSB_dragger[1].parent().width() - mCSB_dragger[1].width(),
                dlt = "y" === o.mouseWheel.axis ? e.deltaY || delta : e.deltaX;
            else
              var dir = "y",
                px = [
                  Math.round(deltaFactor * d.scrollRatio.y),
                  parseInt(o.mouseWheel.scrollAmount),
                ],
                amount =
                  "auto" !== o.mouseWheel.scrollAmount
                    ? px[1]
                    : px[0] >= mCustomScrollBox.height()
                    ? 0.9 * mCustomScrollBox.height()
                    : px[0],
                contentPos = Math.abs(
                  $("#mCSB_" + d.idx + "_container")[0].offsetTop
                ),
                draggerPos = mCSB_dragger[0][0].offsetTop,
                limit =
                  mCSB_dragger[0].parent().height() - mCSB_dragger[0].height(),
                dlt = e.deltaY || delta;
            ("y" === dir && !d.overflowed[0]) ||
              ("x" === dir && !d.overflowed[1]) ||
              ((o.mouseWheel.invert || e.webkitDirectionInvertedFromDevice) &&
                (dlt = -dlt),
              o.mouseWheel.normalizeDelta && (dlt = dlt < 0 ? -1 : 1),
              ((dlt > 0 && 0 !== draggerPos) ||
                (dlt < 0 && draggerPos !== limit) ||
                o.mouseWheel.preventDefault) &&
                (e.stopImmediatePropagation(), e.preventDefault()),
              e.deltaFactor < 5 &&
                !o.mouseWheel.normalizeDelta &&
                ((amount = e.deltaFactor), (dur = 17)),
              _scrollTo($this, (contentPos - dlt * amount).toString(), {
                dir: dir,
                dur: dur,
              }));
          }
        }
      },
      _canAccessIFrameCache = new Object(),
      _canAccessIFrame = function (iframe) {
        var result = !1,
          cacheKey = !1,
          html = null;
        if (
          (void 0 === iframe
            ? (cacheKey = "#empty")
            : void 0 !== $(iframe).attr("id") &&
              (cacheKey = $(iframe).attr("id")),
          !1 !== cacheKey && void 0 !== _canAccessIFrameCache[cacheKey])
        )
          return _canAccessIFrameCache[cacheKey];
        if (iframe) {
          try {
            var doc;
            html = (doc =
              iframe.contentDocument || iframe.contentWindow.document).body
              .innerHTML;
          } catch (err) {}
          result = null !== html;
        } else {
          try {
            var doc;
            html = (doc = top.document).body.innerHTML;
          } catch (err) {}
          result = null !== html;
        }
        return (
          !1 !== cacheKey && (_canAccessIFrameCache[cacheKey] = result), result
        );
      },
      _iframe = function (evt) {
        var el = this.find("iframe");
        if (el.length) {
          var val = evt ? "auto" : "none";
          el.css("pointer-events", val);
        }
      },
      _disableMousewheel = function (el, target) {
        var tag = target.nodeName.toLowerCase(),
          tags = el.data("mCS").opt.mouseWheel.disableOver,
          focusTags = ["select", "textarea"];
        return (
          $.inArray(tag, tags) > -1 &&
          !($.inArray(tag, focusTags) > -1 && !$(target).is(":focus"))
        );
      },
      _draggerRail = function () {
        var $this = $(this),
          d = $this.data("mCS"),
          namespace = "mCS_" + d.idx,
          mCSB_container = $("#mCSB_" + d.idx + "_container"),
          wrapper = mCSB_container.parent(),
          mCSB_draggerContainer,
          clickable;
        $(".mCSB_" + d.idx + "_scrollbar ." + classes[12])
          .bind(
            "mousedown." +
              namespace +
              " touchstart." +
              namespace +
              " pointerdown." +
              namespace +
              " MSPointerDown." +
              namespace,
            function (e) {
              (touchActive = !0),
                $(e.target).hasClass("mCSB_dragger") || (clickable = 1);
            }
          )
          .bind(
            "touchend." +
              namespace +
              " pointerup." +
              namespace +
              " MSPointerUp." +
              namespace,
            function (e) {
              touchActive = !1;
            }
          )
          .bind("click." + namespace, function (e) {
            if (
              clickable &&
              ((clickable = 0),
              $(e.target).hasClass(classes[12]) ||
                $(e.target).hasClass("mCSB_draggerRail"))
            ) {
              _stop($this);
              var el = $(this),
                mCSB_dragger = el.find(".mCSB_dragger");
              if (el.parent(".mCSB_scrollTools_horizontal").length > 0) {
                if (!d.overflowed[1]) return;
                var dir = "x",
                  clickDir = e.pageX > mCSB_dragger.offset().left ? -1 : 1,
                  to =
                    Math.abs(mCSB_container[0].offsetLeft) -
                    clickDir * (0.9 * wrapper.width());
              } else {
                if (!d.overflowed[0]) return;
                var dir = "y",
                  clickDir = e.pageY > mCSB_dragger.offset().top ? -1 : 1,
                  to =
                    Math.abs(mCSB_container[0].offsetTop) -
                    clickDir * (0.9 * wrapper.height());
              }
              _scrollTo($this, to.toString(), {
                dir: dir,
                scrollEasing: "mcsEaseInOut",
              });
            }
          });
      },
      _focus = function () {
        var $this = $(this),
          d = $this.data("mCS"),
          o = d.opt,
          namespace = "mCS_" + d.idx,
          mCSB_container = $("#mCSB_" + d.idx + "_container"),
          wrapper = mCSB_container.parent();
        mCSB_container.bind("focusin." + namespace, function (e) {
          var el = $(document.activeElement),
            nested = mCSB_container.find(".mCustomScrollBox").length,
            dur = 0;
          el.is(o.advanced.autoScrollOnFocus) &&
            (_stop($this),
            clearTimeout($this[0]._focusTimeout),
            ($this[0]._focusTimer = nested ? 17 * nested : 0),
            ($this[0]._focusTimeout = setTimeout(function () {
              var to = [_childPos(el)[0], _childPos(el)[1]],
                contentPos = [
                  mCSB_container[0].offsetTop,
                  mCSB_container[0].offsetLeft,
                ],
                isVisible = [
                  contentPos[0] + to[0] >= 0 &&
                    contentPos[0] + to[0] <
                      wrapper.height() - el.outerHeight(!1),
                  contentPos[1] + to[1] >= 0 &&
                    contentPos[0] + to[1] < wrapper.width() - el.outerWidth(!1),
                ],
                overwrite =
                  "yx" !== o.axis || isVisible[0] || isVisible[1]
                    ? "all"
                    : "none";
              "x" === o.axis ||
                isVisible[0] ||
                _scrollTo($this, to[0].toString(), {
                  dir: "y",
                  scrollEasing: "mcsEaseInOut",
                  overwrite: overwrite,
                  dur: 0,
                }),
                "y" === o.axis ||
                  isVisible[1] ||
                  _scrollTo($this, to[1].toString(), {
                    dir: "x",
                    scrollEasing: "mcsEaseInOut",
                    overwrite: overwrite,
                    dur: 0,
                  });
            }, $this[0]._focusTimer)));
        });
      },
      _wrapperScroll = function () {
        var $this,
          d = $(this).data("mCS"),
          namespace = "mCS_" + d.idx,
          wrapper = $("#mCSB_" + d.idx + "_container").parent();
        wrapper.bind("scroll." + namespace, function (e) {
          (0 === wrapper.scrollTop() && 0 === wrapper.scrollLeft()) ||
            $(".mCSB_" + d.idx + "_scrollbar").css("visibility", "hidden");
        });
      },
      _buttons = function () {
        var $this = $(this),
          d = $this.data("mCS"),
          o = d.opt,
          seq = d.sequential,
          namespace = "mCS_" + d.idx,
          sel = ".mCSB_" + d.idx + "_scrollbar",
          btn;
        $(sel + ">a")
          .bind("contextmenu." + namespace, function (e) {
            e.preventDefault();
          })
          .bind(
            "mousedown." +
              namespace +
              " touchstart." +
              namespace +
              " pointerdown." +
              namespace +
              " MSPointerDown." +
              namespace +
              " mouseup." +
              namespace +
              " touchend." +
              namespace +
              " pointerup." +
              namespace +
              " MSPointerUp." +
              namespace +
              " mouseout." +
              namespace +
              " pointerout." +
              namespace +
              " MSPointerOut." +
              namespace +
              " click." +
              namespace,
            function (e) {
              if ((e.preventDefault(), _mouseBtnLeft(e))) {
                var btnClass = $(this).attr("class");
                switch (((seq.type = o.scrollButtons.scrollType), e.type)) {
                  case "mousedown":
                  case "touchstart":
                  case "pointerdown":
                  case "MSPointerDown":
                    if ("stepped" === seq.type) return;
                    (touchActive = !0),
                      (d.tweenRunning = !1),
                      _seq("on", btnClass);
                    break;
                  case "mouseup":
                  case "touchend":
                  case "pointerup":
                  case "MSPointerUp":
                  case "mouseout":
                  case "pointerout":
                  case "MSPointerOut":
                    if ("stepped" === seq.type) return;
                    (touchActive = !1), seq.dir && _seq("off", btnClass);
                    break;
                  case "click":
                    if ("stepped" !== seq.type || d.tweenRunning) return;
                    _seq("on", btnClass);
                }
              }
              function _seq(a, c) {
                (seq.scrollAmount = o.scrollButtons.scrollAmount),
                  _sequentialScroll($this, a, c);
              }
            }
          );
      },
      _keyboard = function () {
        var $this = $(this),
          d = $this.data("mCS"),
          o = d.opt,
          seq = d.sequential,
          namespace = "mCS_" + d.idx,
          mCustomScrollBox = $("#mCSB_" + d.idx),
          mCSB_container = $("#mCSB_" + d.idx + "_container"),
          wrapper = mCSB_container.parent(),
          editables =
            "input,textarea,select,datalist,keygen,[contenteditable='true']",
          iframe = mCSB_container.find("iframe"),
          events = [
            "blur." +
              namespace +
              " keydown." +
              namespace +
              " keyup." +
              namespace,
          ];
        function _onKeyboard(e) {
          switch (e.type) {
            case "blur":
              d.tweenRunning && seq.dir && _seq("off", null);
              break;
            case "keydown":
            case "keyup":
              var code = e.keyCode ? e.keyCode : e.which,
                action = "on";
              if (
                ("x" !== o.axis && (38 === code || 40 === code)) ||
                ("y" !== o.axis && (37 === code || 39 === code))
              ) {
                if (
                  ((38 === code || 40 === code) && !d.overflowed[0]) ||
                  ((37 === code || 39 === code) && !d.overflowed[1])
                )
                  return;
                "keyup" === e.type && (action = "off"),
                  $(document.activeElement).is(editables) ||
                    (e.preventDefault(),
                    e.stopImmediatePropagation(),
                    _seq(action, code));
              } else if (33 === code || 34 === code) {
                if (
                  ((d.overflowed[0] || d.overflowed[1]) &&
                    (e.preventDefault(), e.stopImmediatePropagation()),
                  "keyup" === e.type)
                ) {
                  _stop($this);
                  var keyboardDir = 34 === code ? -1 : 1;
                  if (
                    "x" === o.axis ||
                    ("yx" === o.axis && d.overflowed[1] && !d.overflowed[0])
                  )
                    var dir = "x",
                      to =
                        Math.abs(mCSB_container[0].offsetLeft) -
                        keyboardDir * (0.9 * wrapper.width());
                  else
                    var dir = "y",
                      to =
                        Math.abs(mCSB_container[0].offsetTop) -
                        keyboardDir * (0.9 * wrapper.height());
                  _scrollTo($this, to.toString(), {
                    dir: dir,
                    scrollEasing: "mcsEaseInOut",
                  });
                }
              } else if (
                (35 === code || 36 === code) &&
                !$(document.activeElement).is(editables) &&
                ((d.overflowed[0] || d.overflowed[1]) &&
                  (e.preventDefault(), e.stopImmediatePropagation()),
                "keyup" === e.type)
              ) {
                if (
                  "x" === o.axis ||
                  ("yx" === o.axis && d.overflowed[1] && !d.overflowed[0])
                )
                  var dir = "x",
                    to =
                      35 === code
                        ? Math.abs(
                            wrapper.width() - mCSB_container.outerWidth(!1)
                          )
                        : 0;
                else
                  var dir = "y",
                    to =
                      35 === code
                        ? Math.abs(
                            wrapper.height() - mCSB_container.outerHeight(!1)
                          )
                        : 0;
                _scrollTo($this, to.toString(), {
                  dir: dir,
                  scrollEasing: "mcsEaseInOut",
                });
              }
          }
          function _seq(a, c) {
            (seq.type = o.keyboard.scrollType),
              (seq.scrollAmount = o.keyboard.scrollAmount),
              ("stepped" === seq.type && d.tweenRunning) ||
                _sequentialScroll($this, a, c);
          }
        }
        iframe.length &&
          iframe.each(function () {
            $(this).bind("load", function () {
              _canAccessIFrame(this) &&
                $(this.contentDocument || this.contentWindow.document).bind(
                  events[0],
                  function (e) {
                    _onKeyboard(e);
                  }
                );
            });
          }),
          mCustomScrollBox.attr("tabindex", "0").bind(events[0], function (e) {
            _onKeyboard(e);
          });
      },
      _sequentialScroll = function (el, action, trigger, e, s) {
        var d = el.data("mCS"),
          o = d.opt,
          seq = d.sequential,
          mCSB_container = $("#mCSB_" + d.idx + "_container"),
          once = "stepped" === seq.type,
          steplessSpeed = o.scrollInertia < 26 ? 26 : o.scrollInertia,
          steppedSpeed = o.scrollInertia < 1 ? 17 : o.scrollInertia;
        switch (action) {
          case "on":
            if (
              ((seq.dir = [
                trigger === classes[16] ||
                trigger === classes[15] ||
                39 === trigger ||
                37 === trigger
                  ? "x"
                  : "y",
                trigger === classes[13] ||
                trigger === classes[15] ||
                38 === trigger ||
                37 === trigger
                  ? -1
                  : 1,
              ]),
              _stop(el),
              _isNumeric(trigger) && "stepped" === seq.type)
            )
              return;
            _on(once);
            break;
          case "off":
            _off(), (once || (d.tweenRunning && seq.dir)) && _on(!0);
        }
        function _on(once) {
          o.snapAmount &&
            (seq.scrollAmount =
              o.snapAmount instanceof Array
                ? "x" === seq.dir[0]
                  ? o.snapAmount[1]
                  : o.snapAmount[0]
                : o.snapAmount);
          var c = "stepped" !== seq.type,
            t =
              s || (once ? (c ? steplessSpeed / 1.5 : steppedSpeed) : 1e3 / 60),
            m = once ? (c ? 7.5 : 40) : 2.5,
            contentPos = [
              Math.abs(mCSB_container[0].offsetTop),
              Math.abs(mCSB_container[0].offsetLeft),
            ],
            ratio = [
              d.scrollRatio.y > 10 ? 10 : d.scrollRatio.y,
              d.scrollRatio.x > 10 ? 10 : d.scrollRatio.x,
            ],
            amount =
              "x" === seq.dir[0]
                ? contentPos[1] + seq.dir[1] * (ratio[1] * m)
                : contentPos[0] + seq.dir[1] * (ratio[0] * m),
            px =
              "x" === seq.dir[0]
                ? contentPos[1] + seq.dir[1] * parseInt(seq.scrollAmount)
                : contentPos[0] + seq.dir[1] * parseInt(seq.scrollAmount),
            to = "auto" !== seq.scrollAmount ? px : amount,
            easing =
              e || (once ? (c ? "mcsLinearOut" : "mcsEaseInOut") : "mcsLinear"),
            onComplete = !!once;
          once &&
            t < 17 &&
            (to = "x" === seq.dir[0] ? contentPos[1] : contentPos[0]),
            _scrollTo(el, to.toString(), {
              dir: seq.dir[0],
              scrollEasing: easing,
              dur: t,
              onComplete: onComplete,
            }),
            once
              ? (seq.dir = !1)
              : (clearTimeout(seq.step),
                (seq.step = setTimeout(function () {
                  _on();
                }, t)));
        }
        function _off() {
          clearTimeout(seq.step), _delete(seq, "step"), _stop(el);
        }
      },
      _arr = function (val) {
        var o = $(this).data("mCS").opt,
          vals = [];
        return (
          "function" == typeof val && (val = val()),
          val instanceof Array
            ? (vals =
                val.length > 1
                  ? [val[0], val[1]]
                  : "x" === o.axis
                  ? [null, val[0]]
                  : [val[0], null])
            : ((vals[0] = val.y ? val.y : val.x || "x" === o.axis ? null : val),
              (vals[1] = val.x ? val.x : val.y || "y" === o.axis ? null : val)),
          "function" == typeof vals[0] && (vals[0] = vals[0]()),
          "function" == typeof vals[1] && (vals[1] = vals[1]()),
          vals
        );
      },
      _to = function (val, dir) {
        if (null != val && void 0 !== val) {
          var $this = $(this),
            d = $this.data("mCS"),
            o = d.opt,
            mCSB_container = $("#mCSB_" + d.idx + "_container"),
            wrapper = mCSB_container.parent(),
            t = typeof val;
          dir || (dir = "x" === o.axis ? "x" : "y");
          var contentLength =
              "x" === dir
                ? mCSB_container.outerWidth(!1) - wrapper.width()
                : mCSB_container.outerHeight(!1) - wrapper.height(),
            contentPos =
              "x" === dir
                ? mCSB_container[0].offsetLeft
                : mCSB_container[0].offsetTop,
            cssProp = "x" === dir ? "left" : "top";
          switch (t) {
            case "function":
              return val();
            case "object":
              var obj;
              if (!(obj = val.jquery ? val : $(val)).length) return;
              return "x" === dir ? _childPos(obj)[1] : _childPos(obj)[0];
            case "string":
            case "number":
              if (_isNumeric(val)) return Math.abs(val);
              if (-1 !== val.indexOf("%"))
                return Math.abs((contentLength * parseInt(val)) / 100);
              if (-1 !== val.indexOf("-="))
                return Math.abs(contentPos - parseInt(val.split("-=")[1]));
              if (-1 !== val.indexOf("+=")) {
                var p = contentPos + parseInt(val.split("+=")[1]);
                return p >= 0 ? 0 : Math.abs(p);
              }
              if (-1 !== val.indexOf("px") && _isNumeric(val.split("px")[0]))
                return Math.abs(val.split("px")[0]);
              if ("top" === val || "left" === val) return 0;
              if ("bottom" === val)
                return Math.abs(
                  wrapper.height() - mCSB_container.outerHeight(!1)
                );
              if ("right" === val)
                return Math.abs(
                  wrapper.width() - mCSB_container.outerWidth(!1)
                );
              if ("first" === val || "last" === val) {
                var obj = mCSB_container.find(":" + val);
                return "x" === dir ? _childPos(obj)[1] : _childPos(obj)[0];
              }
              return $(val).length
                ? "x" === dir
                  ? _childPos($(val))[1]
                  : _childPos($(val))[0]
                : (mCSB_container.css(cssProp, val),
                  void methods.update.call(null, $this[0]));
          }
        }
      },
      _autoUpdate = function (rem) {
        var $this = $(this),
          d = $this.data("mCS"),
          o = d.opt,
          mCSB_container = $("#mCSB_" + d.idx + "_container");
        if (rem)
          return (
            clearTimeout(mCSB_container[0].autoUpdate),
            void _delete(mCSB_container[0], "autoUpdate")
          );
        function upd() {
          clearTimeout(mCSB_container[0].autoUpdate),
            0 !== $this.parents("html").length
              ? (mCSB_container[0].autoUpdate = setTimeout(function () {
                  return o.advanced.updateOnSelectorChange &&
                    ((d.poll.change.n = sizesSum()),
                    d.poll.change.n !== d.poll.change.o)
                    ? ((d.poll.change.o = d.poll.change.n), void doUpd(3))
                    : o.advanced.updateOnContentResize &&
                      ((d.poll.size.n =
                        $this[0].scrollHeight +
                        $this[0].scrollWidth +
                        mCSB_container[0].offsetHeight +
                        $this[0].offsetHeight +
                        $this[0].offsetWidth),
                      d.poll.size.n !== d.poll.size.o)
                    ? ((d.poll.size.o = d.poll.size.n), void doUpd(1))
                    : !o.advanced.updateOnImageLoad ||
                      ("auto" === o.advanced.updateOnImageLoad &&
                        "y" === o.axis) ||
                      ((d.poll.img.n = mCSB_container.find("img").length),
                      d.poll.img.n === d.poll.img.o)
                    ? void (
                        (o.advanced.updateOnSelectorChange ||
                          o.advanced.updateOnContentResize ||
                          o.advanced.updateOnImageLoad) &&
                        upd()
                      )
                    : ((d.poll.img.o = d.poll.img.n),
                      void mCSB_container.find("img").each(function () {
                        imgLoader(this);
                      }));
                }, o.advanced.autoUpdateTimeout))
              : ($this = null);
        }
        function imgLoader(el) {
          if ($(el).hasClass(classes[2])) doUpd();
          else {
            var img = new Image();
            (img.onload = createDelegate(img, imgOnLoad)), (img.src = el.src);
          }
          function createDelegate(contextObject, delegateMethod) {
            return function () {
              return delegateMethod.apply(contextObject, arguments);
            };
          }
          function imgOnLoad() {
            (this.onload = null), $(el).addClass(classes[2]), doUpd(2);
          }
        }
        function sizesSum() {
          !0 === o.advanced.updateOnSelectorChange &&
            (o.advanced.updateOnSelectorChange = "*");
          var total = 0,
            sel = mCSB_container.find(o.advanced.updateOnSelectorChange);
          return (
            o.advanced.updateOnSelectorChange &&
              sel.length > 0 &&
              sel.each(function () {
                total += this.offsetHeight + this.offsetWidth;
              }),
            total
          );
        }
        function doUpd(cb) {
          clearTimeout(mCSB_container[0].autoUpdate),
            methods.update.call(null, $this[0], cb);
        }
        upd();
      },
      _snapAmount = function (to, amount, offset) {
        return Math.round(to / amount) * amount - offset;
      },
      _stop = function (el) {
        var d = el.data("mCS"),
          sel;
        $(
          "#mCSB_" +
            d.idx +
            "_container,#mCSB_" +
            d.idx +
            "_container_wrapper,#mCSB_" +
            d.idx +
            "_dragger_vertical,#mCSB_" +
            d.idx +
            "_dragger_horizontal"
        ).each(function () {
          _stopTween.call(this);
        });
      },
      _scrollTo = function (el, to, options) {
        var d = el.data("mCS"),
          o = d.opt,
          defaults = {
            trigger: "internal",
            dir: "y",
            scrollEasing: "mcsEaseOut",
            drag: !1,
            dur: o.scrollInertia,
            overwrite: "all",
            callbacks: !0,
            onStart: !0,
            onUpdate: !0,
            onComplete: !0,
          },
          options,
          dur = [
            (options = $.extend(defaults, options)).dur,
            options.drag ? 0 : options.dur,
          ],
          mCustomScrollBox = $("#mCSB_" + d.idx),
          mCSB_container = $("#mCSB_" + d.idx + "_container"),
          wrapper = mCSB_container.parent(),
          totalScrollOffsets = o.callbacks.onTotalScrollOffset
            ? _arr.call(el, o.callbacks.onTotalScrollOffset)
            : [0, 0],
          totalScrollBackOffsets = o.callbacks.onTotalScrollBackOffset
            ? _arr.call(el, o.callbacks.onTotalScrollBackOffset)
            : [0, 0];
        if (
          ((d.trigger = options.trigger),
          (0 === wrapper.scrollTop() && 0 === wrapper.scrollLeft()) ||
            ($(".mCSB_" + d.idx + "_scrollbar").css("visibility", "visible"),
            wrapper.scrollTop(0).scrollLeft(0)),
          "_resetY" !== to ||
            d.contentReset.y ||
            (_cb("onOverflowYNone") && o.callbacks.onOverflowYNone.call(el[0]),
            (d.contentReset.y = 1)),
          "_resetX" !== to ||
            d.contentReset.x ||
            (_cb("onOverflowXNone") && o.callbacks.onOverflowXNone.call(el[0]),
            (d.contentReset.x = 1)),
          "_resetY" !== to && "_resetX" !== to)
        ) {
          if (
            ((!d.contentReset.y && el[0].mcs) ||
              !d.overflowed[0] ||
              (_cb("onOverflowY") && o.callbacks.onOverflowY.call(el[0]),
              (d.contentReset.x = null)),
            (!d.contentReset.x && el[0].mcs) ||
              !d.overflowed[1] ||
              (_cb("onOverflowX") && o.callbacks.onOverflowX.call(el[0]),
              (d.contentReset.x = null)),
            o.snapAmount)
          ) {
            var snapAmount =
              o.snapAmount instanceof Array
                ? "x" === options.dir
                  ? o.snapAmount[1]
                  : o.snapAmount[0]
                : o.snapAmount;
            to = _snapAmount(to, snapAmount, o.snapOffset);
          }
          switch (options.dir) {
            case "x":
              var mCSB_dragger = $("#mCSB_" + d.idx + "_dragger_horizontal"),
                property = "left",
                contentPos = mCSB_container[0].offsetLeft,
                limit = [
                  mCustomScrollBox.width() - mCSB_container.outerWidth(!1),
                  mCSB_dragger.parent().width() - mCSB_dragger.width(),
                ],
                scrollTo = [to, 0 === to ? 0 : to / d.scrollRatio.x],
                tso = totalScrollOffsets[1],
                tsbo = totalScrollBackOffsets[1],
                totalScrollOffset = tso > 0 ? tso / d.scrollRatio.x : 0,
                totalScrollBackOffset = tsbo > 0 ? tsbo / d.scrollRatio.x : 0;
              break;
            case "y":
              var mCSB_dragger = $("#mCSB_" + d.idx + "_dragger_vertical"),
                property = "top",
                contentPos = mCSB_container[0].offsetTop,
                limit = [
                  mCustomScrollBox.height() - mCSB_container.outerHeight(!1),
                  mCSB_dragger.parent().height() - mCSB_dragger.height(),
                ],
                scrollTo = [to, 0 === to ? 0 : to / d.scrollRatio.y],
                tso = totalScrollOffsets[0],
                tsbo = totalScrollBackOffsets[0],
                totalScrollOffset = tso > 0 ? tso / d.scrollRatio.y : 0,
                totalScrollBackOffset = tsbo > 0 ? tsbo / d.scrollRatio.y : 0;
          }
          scrollTo[1] < 0 || (0 === scrollTo[0] && 0 === scrollTo[1])
            ? (scrollTo = [0, 0])
            : scrollTo[1] >= limit[1]
            ? (scrollTo = [limit[0], limit[1]])
            : (scrollTo[0] = -scrollTo[0]),
            el[0].mcs ||
              (_mcs(), _cb("onInit") && o.callbacks.onInit.call(el[0])),
            clearTimeout(mCSB_container[0].onCompleteTimeout),
            _tweenTo(
              mCSB_dragger[0],
              property,
              Math.round(scrollTo[1]),
              dur[1],
              options.scrollEasing
            ),
            (!d.tweenRunning &&
              ((0 === contentPos && scrollTo[0] >= 0) ||
                (contentPos === limit[0] && scrollTo[0] <= limit[0]))) ||
              _tweenTo(
                mCSB_container[0],
                property,
                Math.round(scrollTo[0]),
                dur[0],
                options.scrollEasing,
                options.overwrite,
                {
                  onStart: function () {
                    options.callbacks &&
                      options.onStart &&
                      !d.tweenRunning &&
                      (_cb("onScrollStart") &&
                        (_mcs(), o.callbacks.onScrollStart.call(el[0])),
                      (d.tweenRunning = !0),
                      _onDragClasses(mCSB_dragger),
                      (d.cbOffsets = _cbOffsets()));
                  },
                  onUpdate: function () {
                    options.callbacks &&
                      options.onUpdate &&
                      _cb("whileScrolling") &&
                      (_mcs(), o.callbacks.whileScrolling.call(el[0]));
                  },
                  onComplete: function () {
                    if (options.callbacks && options.onComplete) {
                      "yx" === o.axis &&
                        clearTimeout(mCSB_container[0].onCompleteTimeout);
                      var t = mCSB_container[0].idleTimer || 0;
                      mCSB_container[0].onCompleteTimeout = setTimeout(
                        function () {
                          _cb("onScroll") &&
                            (_mcs(), o.callbacks.onScroll.call(el[0])),
                            _cb("onTotalScroll") &&
                              scrollTo[1] >= limit[1] - totalScrollOffset &&
                              d.cbOffsets[0] &&
                              (_mcs(), o.callbacks.onTotalScroll.call(el[0])),
                            _cb("onTotalScrollBack") &&
                              scrollTo[1] <= totalScrollBackOffset &&
                              d.cbOffsets[1] &&
                              (_mcs(),
                              o.callbacks.onTotalScrollBack.call(el[0])),
                            (d.tweenRunning = !1),
                            (mCSB_container[0].idleTimer = 0),
                            _onDragClasses(mCSB_dragger, "hide");
                        },
                        t
                      );
                    }
                  },
                }
              );
        }
        function _cb(cb) {
          return d && o.callbacks[cb] && "function" == typeof o.callbacks[cb];
        }
        function _cbOffsets() {
          return [
            o.callbacks.alwaysTriggerOffsets || contentPos >= limit[0] + tso,
            o.callbacks.alwaysTriggerOffsets || contentPos <= -tsbo,
          ];
        }
        function _mcs() {
          var cp = [mCSB_container[0].offsetTop, mCSB_container[0].offsetLeft],
            dp = [mCSB_dragger[0].offsetTop, mCSB_dragger[0].offsetLeft],
            cl = [
              mCSB_container.outerHeight(!1),
              mCSB_container.outerWidth(!1),
            ],
            pl = [mCustomScrollBox.height(), mCustomScrollBox.width()];
          el[0].mcs = {
            content: mCSB_container,
            top: cp[0],
            left: cp[1],
            draggerTop: dp[0],
            draggerLeft: dp[1],
            topPct: Math.round(
              (100 * Math.abs(cp[0])) / (Math.abs(cl[0]) - pl[0])
            ),
            leftPct: Math.round(
              (100 * Math.abs(cp[1])) / (Math.abs(cl[1]) - pl[1])
            ),
            direction: options.dir,
          };
        }
      },
      _tweenTo = function (
        el,
        prop,
        to,
        duration,
        easing,
        overwrite,
        callbacks
      ) {
        el._mTween || (el._mTween = { top: {}, left: {} });
        var callbacks,
          onStart = (callbacks = callbacks || {}).onStart || function () {},
          onUpdate = callbacks.onUpdate || function () {},
          onComplete = callbacks.onComplete || function () {},
          startTime = _getTime(),
          _delay,
          progress = 0,
          from = el.offsetTop,
          elStyle = el.style,
          _request,
          tobj = el._mTween[prop];
        "left" === prop && (from = el.offsetLeft);
        var diff = to - from;
        function _step() {
          tobj.stop ||
            (progress || onStart.call(),
            (progress = _getTime() - startTime),
            _tween(),
            progress >= tobj.time &&
              ((tobj.time =
                progress > tobj.time
                  ? progress + _delay - (progress - tobj.time)
                  : progress + _delay - 1),
              tobj.time < progress + 1 && (tobj.time = progress + 1)),
            tobj.time < duration
              ? (tobj.id = _request(_step))
              : onComplete.call());
        }
        function _tween() {
          duration > 0
            ? ((tobj.currVal = _ease(tobj.time, from, diff, duration, easing)),
              (elStyle[prop] = Math.round(tobj.currVal) + "px"))
            : (elStyle[prop] = to + "px"),
            onUpdate.call();
        }
        function _startTween() {
          (_delay = 1e3 / 60),
            (tobj.time = progress + _delay),
            (_request = window.requestAnimationFrame
              ? window.requestAnimationFrame
              : function (f) {
                  return _tween(), setTimeout(f, 0.01);
                }),
            (tobj.id = _request(_step));
        }
        function _cancelTween() {
          null != tobj.id &&
            (window.requestAnimationFrame
              ? window.cancelAnimationFrame(tobj.id)
              : clearTimeout(tobj.id),
            (tobj.id = null));
        }
        function _ease(t, b, c, d, type) {
          switch (type) {
            case "linear":
            case "mcsLinear":
              return (c * t) / d + b;
            case "mcsLinearOut":
              return (t /= d), t--, c * Math.sqrt(1 - t * t) + b;
            case "easeInOutSmooth":
              return (t /= d / 2) < 1
                ? (c / 2) * t * t + b
                : (-c / 2) * (--t * (t - 2) - 1) + b;
            case "easeInOutStrong":
              return (t /= d / 2) < 1
                ? (c / 2) * Math.pow(2, 10 * (t - 1)) + b
                : (t--, (c / 2) * (2 - Math.pow(2, -10 * t)) + b);
            case "easeInOut":
            case "mcsEaseInOut":
              return (t /= d / 2) < 1
                ? (c / 2) * t * t * t + b
                : (c / 2) * ((t -= 2) * t * t + 2) + b;
            case "easeOutSmooth":
              return (t /= d), -c * (--t * t * t * t - 1) + b;
            case "easeOutStrong":
              return c * (1 - Math.pow(2, (-10 * t) / d)) + b;
            case "easeOut":
            case "mcsEaseOut":
            default:
              var ts = (t /= d) * t,
                tc = ts * t;
              return (
                b +
                c *
                  (0.499999999999997 * tc * ts +
                    -2.5 * ts * ts +
                    5.5 * tc +
                    -6.5 * ts +
                    4 * t)
              );
          }
        }
        (tobj.stop = 0), "none" !== overwrite && _cancelTween(), _startTween();
      },
      _getTime = function () {
        return window.performance && window.performance.now
          ? window.performance.now()
          : window.performance && window.performance.webkitNow
          ? window.performance.webkitNow()
          : Date.now
          ? Date.now()
          : new Date().getTime();
      },
      _stopTween = function () {
        var el = this;
        el._mTween || (el._mTween = { top: {}, left: {} });
        for (var props = ["top", "left"], i = 0; i < props.length; i++) {
          var prop = props[i];
          el._mTween[prop].id &&
            (window.requestAnimationFrame
              ? window.cancelAnimationFrame(el._mTween[prop].id)
              : clearTimeout(el._mTween[prop].id),
            (el._mTween[prop].id = null),
            (el._mTween[prop].stop = 1));
        }
      },
      _delete = function (c, m) {
        try {
          delete c[m];
        } catch (e) {
          c[m] = null;
        }
      },
      _mouseBtnLeft = function (e) {
        return !(e.which && 1 !== e.which);
      },
      _pointerTouch = function (e) {
        var t = e.originalEvent.pointerType;
        return !(t && "touch" !== t && 2 !== t);
      },
      _isNumeric = function (val) {
        return !isNaN(parseFloat(val)) && isFinite(val);
      },
      _childPos = function (el) {
        var p = el.parents(".mCSB_container");
        return [
          el.offset().top - p.offset().top,
          el.offset().left - p.offset().left,
        ];
      },
      _isTabHidden = function () {
        var prop = _getHiddenProp();
        return !!prop && document[prop];
        function _getHiddenProp() {
          var pfx = ["webkit", "moz", "ms", "o"];
          if ("hidden" in document) return "hidden";
          for (var i = 0; i < pfx.length; i++)
            if (pfx[i] + "Hidden" in document) return pfx[i] + "Hidden";
          return null;
        }
      };
    ($.fn[pluginNS] = function (method) {
      return methods[method]
        ? methods[method].apply(this, Array.prototype.slice.call(arguments, 1))
        : "object" != typeof method && method
        ? void $.error("Method " + method + " does not exist")
        : methods.init.apply(this, arguments);
    }),
      ($[pluginNS] = function (method) {
        return methods[method]
          ? methods[method].apply(
              this,
              Array.prototype.slice.call(arguments, 1)
            )
          : "object" != typeof method && method
          ? void $.error("Method " + method + " does not exist")
          : methods.init.apply(this, arguments);
      }),
      ($[pluginNS].defaults = defaults),
      (window[pluginNS] = !0),
      $(window).bind("load", function () {
        $(defaultSelector)[pluginNS](),
          $.extend($.expr[":"], {
            mcsInView:
              $.expr[":"].mcsInView ||
              function (el) {
                var $el = $(el),
                  content = $el.parents(".mCSB_container"),
                  wrapper,
                  cPos;
                if (content.length)
                  return (
                    (wrapper = content.parent()),
                    (cPos = [content[0].offsetTop, content[0].offsetLeft])[0] +
                      _childPos($el)[0] >=
                      0 &&
                      cPos[0] + _childPos($el)[0] <
                        wrapper.height() - $el.outerHeight(!1) &&
                      cPos[1] + _childPos($el)[1] >= 0 &&
                      cPos[1] + _childPos($el)[1] <
                        wrapper.width() - $el.outerWidth(!1)
                  );
              },
            mcsInSight:
              $.expr[":"].mcsInSight ||
              function (el, i, m) {
                var $el = $(el),
                  elD,
                  content = $el.parents(".mCSB_container"),
                  wrapperView,
                  pos,
                  wrapperViewPct,
                  pctVals =
                    "exact" === m[3]
                      ? [
                          [1, 0],
                          [1, 0],
                        ]
                      : [
                          [0.9, 0.1],
                          [0.6, 0.4],
                        ];
                if (content.length)
                  return (
                    (elD = [$el.outerHeight(!1), $el.outerWidth(!1)]),
                    (pos = [
                      content[0].offsetTop + _childPos($el)[0],
                      content[0].offsetLeft + _childPos($el)[1],
                    ]),
                    (wrapperView = [
                      content.parent()[0].offsetHeight,
                      content.parent()[0].offsetWidth,
                    ]),
                    pos[0] -
                      wrapperView[0] *
                        (wrapperViewPct = [
                          elD[0] < wrapperView[0] ? pctVals[0] : pctVals[1],
                          elD[1] < wrapperView[1] ? pctVals[0] : pctVals[1],
                        ])[0][0] <
                      0 &&
                      pos[0] + elD[0] - wrapperView[0] * wrapperViewPct[0][1] >=
                        0 &&
                      pos[1] - wrapperView[1] * wrapperViewPct[1][0] < 0 &&
                      pos[1] + elD[1] - wrapperView[1] * wrapperViewPct[1][1] >=
                        0
                  );
              },
            mcsOverflow:
              $.expr[":"].mcsOverflow ||
              function (el) {
                var d = $(el).data("mCS");
                if (d) return d.overflowed[0] || d.overflowed[1];
              },
          });
      });
  }),
    (_rjs = "function" == typeof define && define.amd),
    (_njs = "undefined" != typeof module && module.exports),
    (_dlp = "https:" == document.location.protocol ? "https:" : "http:"),
    (_url =
      "cdnjs.cloudflare.com/ajax/libs/jquery-mousewheel/3.1.13/jquery.mousewheel.min.js"),
    _rjs ||
      (_njs
        ? require("./jquery-mousewheel")($)
        : $.event.special.mousewheel ||
          $("head").append(
            decodeURI(
              "%3Cscript src=" + _dlp + "//" + _url + "%3E%3C/script%3E"
            )
          )),
    init();
});

export function init_customscrollbar() {
  if (jQuery(".vscroll").length > 0) {
    jQuery(".vscroll").each(function () {
      var height = jQuery(this).data("height") || 200;

      jQuery(this).mCustomScrollbar({
        axis: "y",
        setHeight: height,
        scrollInertia: 0,
        autoHideScrollbar: false,
        autoDraggerLength: true,
        theme: "dark-thick",
        contentTouchScroll: 1,
        mouseWheel: {
          enable: true,
          preventDefault: true,
          axis: "y",
          scrollAmount: 30,
        },
      });
    });
  }
}

jQuery(window).on("load", function () {
  init_customscrollbar();
});
